<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="viii"></a><a id="contents"></a>Contents</h2>
<p class="para"> </p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td valign="top"><p class="para3"><a href="#/Text/frontmatter01" id="ah1"><strong>Introduction</strong></a></p>
</td>
<td valign="top"><p class="para2a"> </p>
</td>
</tr>
<tr>
<td valign="top"><p class="para2"><span href="#/Text/chapter01" id="ah2" title="Link target outside of Sample"><strong>Chapter 1</strong></span></p>
</td>
<td valign="top"><p class="para2a"><span href="#/Text/chapter01" title="Link target outside of Sample">The Alchemy of the Soul</span></p>
</td>
</tr>
<tr>
<td valign="top"><p class="para2"><span href="#/Text/chapter02" id="ah3" title="Link target outside of Sample"><strong>Chapter 2</strong></span></p>
</td>
<td valign="top"><p class="para2a"><span href="#/Text/chapter02" title="Link target outside of Sample">Stop the Reaction</span></p>
</td>
</tr>
<tr>
<td valign="top"><p class="para2"><span href="#/Text/chapter03" id="ah4" title="Link target outside of Sample"><strong>Chapter 3</strong></span></p>
</td>
<td valign="top"><p class="para2a"><span href="#/Text/chapter03" title="Link target outside of Sample">Transmute the Energy</span></p>
</td>
</tr>
<tr>
<td valign="top"><p class="para2"><span href="#/Text/chapter04" id="ah5" title="Link target outside of Sample"><strong>Chapter 4</strong></span></p>
</td>
<td valign="top"><p class="para2a"><span href="#/Text/chapter04" title="Link target outside of Sample">More Tools for Transformation</span></p>
</td>
</tr>
<tr>
<td valign="top"><p class="para2"><span href="#/Text/chapter05" id="ah6" title="Link target outside of Sample"><strong>Chapter 5</strong></span></p>
</td>
<td valign="top"><p class="para2a"><span href="#/Text/chapter05" id="ah7" title="Link target outside of Sample">The Nature of Projections</span></p>
</td>
</tr>
<tr>
<td valign="top"><p class="para2"><span href="#/Text/chapter06" id="ah17" title="Link target outside of Sample"><strong>Chapter 6</strong></span></p>
</td>
<td valign="top"><p class="para2a"><span href="#/Text/chapter06" id="ah8" title="Link target outside of Sample">A Time for Reflection</span></p>
</td>
</tr>
<tr>
<td valign="top"><p class="para2"><span href="#/Text/chapter07" id="ah9" title="Link target outside of Sample"><strong>Chapter 7</strong></span></p>
</td>
<td valign="top"><p class="para2a"><span href="#/Text/chapter07" id="ah10" title="Link target outside of Sample">Protect Yourself in a Toxic World</span></p>
</td>
</tr>
<tr>
<td valign="top"><p class="para2"><span href="#/Text/chapter08" id="ah11" title="Link target outside of Sample"><strong>Chapter 8</strong></span></p>
</td>
<td valign="top"><p class="para2a"><span href="#/Text/chapter08" id="ah12" title="Link target outside of Sample">Toward a New Evolution of Consciousness</span></p>
</td>
</tr>
<tr>
<td valign="top"><p class="para2"><span href="#/Text/backmatter01" id="ah13" title="Link target outside of Sample"><strong>Appendix</strong></span></p>
</td>
<td valign="top"><p class="para2a"><span href="#/Text/backmatter01" id="ah14" title="Link target outside of Sample">Frequently Asked Questions</span></p>
</td>
</tr>
<tr>
<td valign="top"><p class="para3"><span href="#/Text/backmatter02" id="ah15" title="Link target outside of Sample"><strong>About the Author</strong></span></p>
</td>
<td valign="top"><p class="para2a"> </p>
</td>
</tr>
<tr>
<td valign="top"><p class="para3"><span href="#/Text/backmatter03" id="ah16" title="Link target outside of Sample"><strong>Acknowledgments</strong></span></p>
</td>
<td valign="top"><p class="para2a"> </p>
</td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?69ea5ff2